import { create } from "zustand";
import Cookies from "js-cookie";

export const useAuth = create((set) => ({
  user: JSON.parse(localStorage.getItem("user")) || null,
  token: Cookies.get("token") || null,

  login: (user, token) => {
    Cookies.set("token", token, { expires: 7, sameSite: "lax" });
    localStorage.setItem("user", JSON.stringify(user));
    set({ user, token });
  },

  logout: () => {
    Cookies.remove("token");
    localStorage.removeItem("user");
    set({ user: null, token: null });
  },
}));
